import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';
import type { ItemContentType } from './item.ts';

export interface AgentReviewWebCitation {
    type: 'web';
    title?: string | null;
    url: string;
}

export interface AgentReviewAttachmentCitation {
    type: 'attachment';
    title: string;
    attachmentId: string;
}

export type AgentReviewCitation = AgentReviewWebCitation | AgentReviewAttachmentCitation;

export interface AgentReviewFinding {
    text: string;
    citations: AgentReviewCitation[];
}

export interface AgentPart {
    type: 'text' | 'tool' | 'attachment' | 'context' | 'error';
    id?: string;
    text?: string;
    name?: string;
    mimeType?: string;
    itemId?: number;
    revisionId?: number;
    revisionNumber?: number;
    contentType?: ItemContentType;
    status?: 'running' | 'completed' | 'failed' | 'stopped';
    error?: string;
    labels?: {
        running?: string;
        completed?: string;
        failed?: string;
    };
    result?: {
        reviewId?: number;
        itemId?: number;
        contentType?: ItemContentType;
        revisionId?: number;
        revisionNumber?: number;
        createdItem?: boolean;
        url?: string;
        summary?: string;
        findings?: AgentReviewFinding[];
    };
}

export interface AgentTranscriptMessage {
    id: string;
    role: 'user' | 'assistant';
    parts: AgentPart[];
}

export interface AgentActiveTurn {
    invocationId: string;
    user: AgentTranscriptMessage;
    assistant: AgentTranscriptMessage;
}

export class AgentConversation extends Model<Schemas['agentConversations'], Models> {
    get activeTurnSnapshot() {
        return this.activeTurn as unknown as AgentActiveTurn | null;
    }

    get updatedAtDate() {
        return nullableDate(this.updatedAt);
    }
}

export class AgentConversationMessage extends Model<Schemas['agentConversationMessages'], Models> {
    declare parts: AgentPart[];
}
